import { Button, Result, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { semanticTheme } from '@tools/ui/dime';

const { Text, Paragraph } = Typography;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: ${semanticTheme.dime.colors.background.secondary};
`;

const RouteInfo = styled.div`
  background-color: ${semanticTheme.dime.colors.surface.secondary};
  border: 1px solid ${semanticTheme.dime.colors.border.static};
  border-radius: ${semanticTheme.dime.radius.s};
  padding: ${semanticTheme.dime.spacing.m} ${semanticTheme.dime.spacing.l};
  margin-top: ${semanticTheme.dime.spacing.l};
  text-align: left;
`;

type UnconfiguredRouteScreenProps = {
  routePath: string;
  moduleName?: string;
};

export const UnconfiguredRouteScreen: React.FC<UnconfiguredRouteScreenProps> = ({
  routePath,
  moduleName,
}) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Result
        status="warning"
        title={t('unconfiguredRoute.title')}
        subTitle={t('unconfiguredRoute.subtitle')}
        extra={[
          <Link key="settings" to="/settings/modules">
            <Button type="primary">{t('unconfiguredRoute.goToSettings')}</Button>
          </Link>,
        ]}
      >
        <RouteInfo>
          <Paragraph>
            <Text strong>{t('unconfiguredRoute.routePath')}: </Text>
            <Text code>{routePath}</Text>
          </Paragraph>
          {Boolean(moduleName) && (
            <Paragraph style={{ marginBottom: 0 }}>
              <Text strong>{t('unconfiguredRoute.moduleName')}: </Text>
              <Text>{moduleName}</Text>
            </Paragraph>
          )}
        </RouteInfo>
      </Result>
    </Container>
  );
};
